module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bjcx"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "priceForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "80px",
      "size": "mini"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "目的地"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "请输入目的地"
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.$set(_vm.form, "country", $$v)
      },
      expression: "form.country"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计费重"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "请输入计费重"
    },
    model: {
      value: (_vm.form.rweight),
      callback: function($$v) {
        _vm.$set(_vm.form, "rweight", $$v)
      },
      expression: "form.rweight"
    }
  }, [_c('template', {
    slot: "suffix"
  }, [_vm._v("KG")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "mini",
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.form.goodstype),
      callback: function($$v) {
        _vm.$set(_vm.form, "goodstype", $$v)
      },
      expression: "form.goodstype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "文件",
      "value": "DOC"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "包裹",
      "value": "WPX"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "native-type": "submit",
      "icon": "el-icon-search"
    }
  }, [_vm._v("开始计算")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "xy-title"
  }, [_c('b', [_vm._v("报价查询")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff597c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/xy-price-form.vue
// module id = 723
// module chunks = 1